import React, { Component, PropTypes } from 'react'
import { Link, IndexLink } from 'react-router'
import { lang } from '../strings'
import { Start, Subscriptions, Invoices, Password, Logout } from './svg'

export default class Nav extends Component {
  render() {
    let { authenticated, onLogOut } = this.props

    if (!authenticated) {
      return null
    }

    return (
      <ul className='mp-menu'>
        <li className={this.activeClass('customer')}>
          <IndexLink to='/' className='link'>
            <Start /> {lang.nav.customer}
          </IndexLink>
        </li>
        <li className={this.activeClass('subscriptions')}>
          <Link to='/subscriptions' className='link'>
            <Subscriptions /> {lang.nav.subscriptions}
          </Link>
        </li>
        <li className={this.activeClass('invoices')}>
          <Link to='/invoices' className='link'>
            <Invoices /> {lang.nav.invoices}
          </Link>
        </li>
        <li className={this.activeClass('changePassword')}>
          <Link to='/changePassword' className='link'>
            <Password /> {lang.nav.changePassword}
          </Link>
        </li>
        <li>
          <a href='#' className='link' onClick={onLogOut}>
            <Logout /> {lang.nav.logout}
          </a>
        </li>
      </ul>
    )
  }

  activeClass(routeName) {
    return this.context.router.isActive(routeName, false) ? 'active' : ''
  }
}

Nav.contextTypes = {
  router: PropTypes.object.isRequired,
}

Nav.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  onLogOut: PropTypes.func.isRequired,
}
